import { render } from "./designated-site-info.vue?vue&type=template&id=6bad5764&scoped=true"
import script from "./designated-site-info.vue?vue&type=script&lang=js"
export * from "./designated-site-info.vue?vue&type=script&lang=js"

import "./designated-site-info.vue?vue&type=style&index=0&id=6bad5764&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bad5764"]])

export default __exports__